import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../core/services/auth.service';

/**
 * Guard que valida el acceso a rutas protegidas en cada navegación.
 * Primero verifica si hay sesión válida en memoria, luego intenta validar token de URL.
 * @returns true si hay sesión válida o el token de URL es válido
 */
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.getCurrentUser()) {
    return true;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');

  if (token && authService.validateAndStoreToken(token)) {
    window.history.replaceState({}, document.title, window.location.pathname);
    return true;
  }

  router.navigate(['/access-denied']);
  return false;
};